/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import Grid from '../../../containers/dashboard/grid';
import Error from '../../../containers/error-tracking';
import {getTaskColumns, getTasksReserved} from '../../../store/tasks/selectors';
import {qualityGetTasks} from "../../../store/quality/actions";
import {getErrorreports} from "../../../store/quality/selectors";
import {dispoGetDepartments, dispoGetUser} from "../../../store/dispo/actions";
import {getworkstepcount} from "../../../store/tasks/actions";

class QualityGrid extends React.Component {


    componentDidMount() {
        const {
            qualityGetTasks, getworkstepcount
        } = this.props;
        qualityGetTasks();
        getworkstepcount();
    }

    render() {
        const {tasks, columns} = this.props;

        return (
            <Grid
                tasks={tasks}
                columns={columns}
                taskComponent={Error}
                errortracking={true}
            />
        );
    }
}

export default connect(
    state => ({
        tasks: getErrorreports(state),
        columns: getTaskColumns(state, getErrorreports),
    }), {
        qualityGetTasks,
        dispoGetUser,
        dispoGetDepartments,
        getworkstepcount
    }
)(QualityGrid);



// WEBPACK FOOTER //
// ./src/containers/dashboard/grid/quality.js